import React, { useState } from 'react'
import TextEditor from '../../../textEditor/TextEditor'
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../firebase/AuthProvider';
import { UpdateInformationAsync } from '../../../../../services/templateService/TemplateTaskService';
import { UpdateInformationReqeust } from '../../../../../interfaces/templateTask/TemplateRequiresFile';

interface UpdateInformationProps {
    taskTemplateId: number,
    informationData: string
}

const UpdateInformation: React.FC<UpdateInformationProps> = ({
    taskTemplateId,
    informationData
}) => {
    const { currentUser } = useAuth();
    const [information, setInformation] = useState<string>(informationData);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleInfoChange = (infoText: string) => {
        setInformation(infoText);
    };

    const UpdateInformation = async () => {
        if (!information) toast.error("Please Enter the Information");
        const token = await currentUser?.getIdToken();

        if (!token) return;
        const payload: UpdateInformationReqeust = {
            templateTaskId: taskTemplateId,
            information: information
        }
        try {
            setIsLoading(true);
            const res = await UpdateInformationAsync(token, payload);

            if (res.success) {
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
        } catch (error: any) {
            toast.error(error.message || "Error to Update the Information ")
        } finally { setIsLoading(false) }
    }
    return (
        <div className='common_card'>
            <div className="custom_input_flled">
                <label htmlFor="info">Information</label>
                <TextEditor
                    text={information}
                    setText={handleInfoChange}
                />
            </div>
            <div>
                <Button onClick={UpdateInformation} disabled={isLoading}>
                   {isLoading ? <span> <Spinner size='sm' /> Updating... </span> : "Update" } 
                </Button>
            </div>
        </div>
    )
}

export default UpdateInformation